import { Button, IconButton } from "@hortis/ui/button";
import { DialogClose, DialogContent } from "@hortis/ui/dialog";
import { ArrowUpRight, XClose } from "@hortis/ui/icons";
import type { RELEASE_NOTE_QUERYResult } from "generated/sanity.types";
import { PortableText } from "./portable-text";

export const ReleaseNoteDialogContent = ({
  releaseNote,
}: {
  releaseNote: NonNullable<RELEASE_NOTE_QUERYResult>;
}) => {
  return (
    <DialogContent className="flex max-h-[calc(100%-32px)] max-w-xl flex-col gap-0! p-0!">
      <div className="flex items-center justify-between gap-3 border-b border-grey-200 px-6 py-2">
        <div className="flex items-center gap-3 text-sm font-medium text-grey-500">
          {releaseNote.title}
        </div>
        <div className="flex items-center gap-0.5">
          <Button
            asChild
            endIcon={ArrowUpRight}
            size="xs"
            variant="tertiaryColor"
          >
            <a
              href="https://hortis.com/changelog"
              target="_blank"
              rel="noreferrer"
            >
              Changelog
            </a>
          </Button>
          <DialogClose>
            <IconButton
              icon={XClose}
              variant="tertiaryGray"
              ariaLabel="Close"
              size="xs"
            />
          </DialogClose>
        </div>
      </div>
      <div className="overflow-auto p-6">
        {releaseNote.featureImage != null &&
          "_id" in releaseNote.featureImage &&
          releaseNote.featureImage.url != null && (
            <img
              src={`${releaseNote.featureImage.url}?auto=format`}
              className="col-span-4 overflow-hidden rounded-xl"
              alt="Release note feature"
            />
          )}
        <PortableText value={releaseNote.content} />
      </div>
    </DialogContent>
  );
};
